import { ReportsView } from "@/features/reports";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/reports/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <ReportsView />;
}
